// extracted by css-extract-rspack-plugin
export default {"root":"root-RhmlfF","container":"container-Hjuokn","workspaceLogo":"workspaceLogo-xhB9RB"};